import { EyeIcon, HeartIcon } from "@heroicons/react/24/solid";
import { useSelector } from "react-redux";

function IsInUserList({ id }) {
  const { favorites = [], watchlistMovies = [] } = useSelector((state) => state.user);
  const isFavorite = favorites.some((video) => video.id === id);
  const isUnfinished = watchlistMovies.some((video) => video.videoId === id && video.resumeAt > 0);
  console.log("IsInUserList id:", id,isFavorite);

  return (
    <div className="absolute top-2 md:top-3 right-3 z-10 w-[1.8rem] md:w-[2rem] lg:w-[2.2rem] flex flex-col gap-2">
      {isFavorite && (
        <div className="bg-red-800 rounded-full p-1" title="Nella tua lista preferiti">
          <HeartIcon className="text-red-200" />
        </div>
      )}
      {isUnfinished && (
        <div className="bg-orange-800 rounded-full p-1" title="Da finire di guardare">
          <EyeIcon className="text-orange-200" />
        </div>
      )}
    </div>
  );
}

export default IsInUserList;
